const BaseUrl = process.env.REACT_APP_BASE_URL;
export const API_URL = {
  saveOnboardUserDetails: "/user_onboard/api/v1/saveUser",
  updateOnboardUserDetails: "/user_onboard/api/v1/updateUser",
  userListing: "/user_onboard/api/v1/getAllUsers",
  changeUserStatus: "/user_onboard/api/v1/changeUserStatus",
  departmentListing: "/user_onboard/user/get_all_dept",
  roleListing: "/user_onboard/user/get_all_func",
  userTypeListing: "/user_onboard/api/v1/userTypes",
  userRolesDetails: "/user_onboard/user/user-roles-details",
  userRoleAccess: "/user_onboard/user/role-access",
  addRoleAccess: "/user_onboard/user/add-role-access",
  userUserRoleAccess: "/user_onboard/user/user/role-access",
  editUserRolePermission: "/user_onboard/api/v1/editUserPerm",
  spareUpload: "/photo_upload/api/v1/upload",
  spareDetailsById: "/spm_service/spare_part/spare",
  sparePhotosById: "/photo_upload/api/v1/photo-details",
  spareDeletImg: "/photo_upload/api/v1/delete",
  sparePhotosPrev: "/photo_upload/api/v1/image-v1",
  sparePhotosDownload: "/photo_upload/api/v1/downloadFile",
  validateEmail: "/uaa/api/v1/validate",
  signIn: "/uaa/api/v1/authenticate",
  sendOtp: "/uaa/api/v1/sendOTP",
  verifyOtp: "/uaa/api/v1/validateotp",
  resendOTP: "/uaa/api/v1/resendOTP",
  logout: "/uaa/api/v1/logout",
  generateTokenForForgotPassword: "/uaa/api/v1/generateToken",
  generateTokenInsideAppForgotPass: "/user_onboard_nonril/auth/generateTempTokenInternal",
  generateTokenForUserOnboard: "/user_onboard_nonril/api/v1/userToken",
  forgotPassword: "/uaa/api/v1/forgetPassword",
  nonRilSaveOnboardUserDetails: "/user_onboard_nonril/api/v1/saveUser",
  nonRilUpdateOnboardUserDetails: "/user_onboard_nonril/api/v1/updateUser",
  serviceAdvisoryListing: "/service_advisory/api/v1/get-advisory-docs-filter",
  serviceGetAdvisoryDocListing:
    "/service_advisory/api/v1/get-advisory-docs-list",
  serviceGetTechDocListing: "/technical_doc/api/v1/get-technical-docs-list",
  serviceAdvisoryUploadFile: "/service_advisory/api/v1/upload-advisory-docs",
  serviceAdvisoryUpdateFile: "/service_advisory/api/v1/edit-advisory-docs",
  serviceAdvisoryModelListing:
    "/service_advisory/api/v1/get-model-by-brand-and-brick",
    serviceAdvisoryModelDeptListing:
    "/service_advisory/api/v1/getCombinedDetails",
  getModelDescriptionOnSelectedModelId:
    "/service_advisory/api/v1/get-model-description",
  nonrilUSERUserRoleAccess: "/user_onboard/user/user/role-access",
  getAdvisoryDocs: "/service_advisory/api/v1/get-advisory-docs-v1",
  getTechnicalDocs: "/technical_doc/api/v1/get-docs-v1",
  downloadUsersTemplate: "/user_onboard/api/v1/get-users-template",
  techDocModelDeptListing: "/technical_doc/api/v1/temp",
  getTechVersion: "/technical_doc/api/v1/get-technical-version",
  downloadTechDocHistoryService: "/technical_doc/api/v1/get-docs-version",
  downloadModelsTemplate:
    "/mm/model_master/download_model_bulk_upload_template",
  downloadSparesTemplate: "/spm/spare_master/spare-upload-template",
  downloadSparesActionTemplate: "/spm/spare_master/spare-action-download-template",
  downloadSparesStatusTemplate: "/spm/spare_master/spare-status-download-template",
  uploadBulkUsers: "/user_onboard/api/v1/upload-users",
  triggerPhotoUpload: "/photo_upload/api/v1/trigger_photos",
  uploadBulkModels: "/mm/model_master/bulk_upload_model_data",
  uploadBulkSpares: "/spm/spare_master/spare-bulk-upload",
  uploadBulkSpareAction: "/spm/spare_master/spare-action-bulk-upload",
  uploadBulkSpareStatus: "/spm/spare_master/spare-status-bulk-upload",
  vendorDetailsInAddSpare: "/master_service/vendor/vendor-details",
  downloadAlternateAndLinkedSpares:
    "/spm_service/spare_part/download_alt_and_linked_spares",
  downloadErorLogs: "/master_service/bulk-upload/download-errors",
  downloadSpareMasterErrorLogs: "/spm/spare_master/download-errors",
  downloadPhotoErorLogs: "/photo_upload/api/v1/download_error",
  downloadModelsBySpareId:
    "/spm_service/spare_part/download_models_by_spare_id",
  getNotificationList: "/notification_service/notifications/get_notifications",
  getNotificationCounts:
    "/notification_service/notifications/get_notifications_count",
  readNotification: "/notification_service/notifications/read_notifications",
  addBroadCast: "/notification_service/notifications/add_broadcast",
  portalGuideDownload: "/master_service/bulk-upload/download-document-v1",
  unlockUser: "/user_onboard_nonril/auth/unlock-user",
  departmentsListing: "/user_onboard/user/get_all_dept",
  changeDepartmentStatus: "/user_onboard/user/change_dept_status",
  addDepartmentDetails: "/user_onboard/user/add_dept",
  updateDepartmentDetails: "/user_onboard/user/edit_dept",
  FunctionListing: "/user_onboard/user/get_all_func",
  changeFunctionStatus: "/user_onboard/user/change_func_status",
  addFunctionDetails: "/user_onboard/user/add_func",
  updateFunctionDetails: "/user_onboard/user/edit_func",
  fetchNotificationDetails : "/notification_service/notifications/get_notifications_count",
  downloadBroadCast : "/notification_service/notifications/download_broadcast",
  changeTechDocStatus : "/technical_doc/api/v1/changeStatus",
  modelAndDeptDetail : "/technical_doc/api/v1/getModelsAndDeptDetails",
  deleteTechDoc: "/technical_doc/api/v1/delete/doc",
  modelAndDeptAdvDetail : "/service_advisory/api/v1/getModelsAndDeptDetails",
  deleteServiceAdvisory: "/service_advisory/api/v1/delete/advisory",
  changeServiceAdvStatus : "/service_advisory/api/v1/changeStatus"
  
};

export const BRAND_LIST_API_URL = {
  brandListing: "/master_service/master/brands",
  saveProductCategoryDetails: "/master_service/master/addCategory",
  categoryListing: "/master_service/master/product-categories",
  saveProductBrickDetails: "/master_service/master/addBrick",
  saveBrandDetails: "/master_service/master/addBrand",
  getBrickListOnSelectedFamily: "/master_service/master/product-bricks",
  updateBrandDetails: "/master_service/master/update-brand",
  getAllBrandsWithOrWithoutBrickId: "/master_service/master/brands-with-brick",
  getAllBricksWithOrWithoutBrandId: "/master_service/master/bricks-with-brands",
  getCategoryListOnSelectedBrand:
    "/master_service/master/categories-with-brand",
  changeBrandStatus: "/master_service/master/update-brand-status",
  saveProductFamilyDetails: "/master_service/master/addProductFamily",
  getFamilyListingWithOrWithoutCategory:
    "/master_service/master/product-family",
  getAllBrandsListing: "/master_service/master/all_brands",
  changeProductCategoryStatus: "/master_service/master/update-category-status",
  updateProductCategoryDetails: "/master_service/master/update-category",
  changeProductFamilyStatus:
    "/master_service/master/update-product-family-status",
  updateProductFamilyDetails: "/master_service/master/updateProductFamily",
  updateProductBrickDetails: "/master_service/master/update-brick",
  changeProductBrickStatus: "/master_service/master/update-brick-status",
  changeBrandBrickMappingStatus:
    "/master_service/master/update-brand-brick-mapping-status",
    getAllDropDownList: "/master_service/master/get-all-dropdown-values",
    getAllDropDown: "/master_service/master/get-all-dropdown"
};

export const MODEL_VIEW_API_URL = {
  modelListing: "/model_service/api/v1/getAllModels",
  changeModelStatus: "/mm/model_master/model-status",
  saveModelDetails: "/mm/model_master/add-model",
  updateModelDetails: "/mm/model_master/update-model",
  getCategoryWithBrandId: "/master_service/master/category-with-brand",
  downloadModels: "/mm/model_master/download_models",
};

export const VENDOR_API_URL = {
  vendorListing: "/master_service/vendor/all",
  vendorChangeStatus: "/master_service/vendor/update-status",
  vendorAndSupplierTypeListing: "/master_service/vendor/types",
  saveVendorDetails: "/master_service/vendor/add-supplier-vendor",
  editVendorDetails: "/master_service/vendor/update-supplier-vendor",
};
export const PARTTYPE_API_URL = {
  partTypeListing: "/spm/spare_master/all_parts",
  typeChangeStatus: "/spm/spare_master/update-part-type-status",
  vendorAndSupplierTypeListing: "/master_service/vendor/types",
  savePartTypeDetails: "/spm/spare_master/add-part-type",
  editpartTypeDetails: "/spm/spare_master/edit-part-type",
};

export const SPARE_API_URL = {
  spareListing: "/spm_service/spare_part/spares",
  statusListing: "/spm/spare_master/status",
  partTypeListing: "/spm/spare_master/parts",
  saveSpareDetails: "/spm/spare_master/add-spare",
  updateSpareDetails: "/spm/spare_master/update-spare",
  actionListing: "/spm/spare_master/actions",
  spareStatusListing: "/spm/spare_master/spare-status",
  fetchSpareDetailsById: "/spm_service/spare_part/spare",
  spareByModelId: "/spm_service/spare_part/spare_by_model_id",
  findSpareByArticleCode: "/spm/spare_master/spare-by-code",
  linkSpareWithModel: "/spm/spare_master/map-spare-model",
  getAlternateSpareBySpareId:
    "/spm_service/spare_part/get-alt-spare-by-spare-id",
  linkAlternateSpare: "/spm/spare_master/map-spare-alternate-spare",
  updateSpareStatus: "/spm/spare_master/update-spare-status",
  downloadSpareDetails: "/spm_service/spare_part/download_spares",
  getModelBySpare: "/spm_service/spare_part/get-model-by-spare",
  getVendorBySpare: "/spm/spare_master/get-vendor-details-by-spare-id",
  deleteSpare: "/spm_service/spare_part/delete-spare"
};

export const TECHNICAL_DOCUMENT_LIST_URL = {
  getDocTypeListing: "/technical_doc/api/v1/doc-types",
  fetchTechnicalDocumentList: "/technical_doc/api/v1/get-technical-docs",
  uploadFile: "/technical_doc/api/v1/upload-docs",
  updateFile: "/technical_doc/api/v1/editTechnicalDoc",
  uploadFileSoftware: "/technical_doc/api/v1/upload-docs-software",
  updateFileSoftware: "/technical_doc/api/v1/update-docs-software",
};

export const BASE_URL_SERVICE_ADVISORY = BaseUrl;
export const BASE_URL = BaseUrl;
export const BASE_URL_MASTERS = BaseUrl;
export const BASE_URL_MODEL_LIST = BaseUrl;
export const BASE_URL_MODEL = BaseUrl;
export const BASE_URL_SPARE = BaseUrl;
export const BASE_URL_SPARE_LIST = BaseUrl;
